/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by andrebarata on 2018-09-14.
 */


'use strict';

import { NgModule }             from '@angular/core';
import { BrowserModule }        from '@angular/platform-browser';
import { FormsModule }          from '@angular/forms';
import { AutoCompleteComponent }  from './component';
import { LKIcon } from '../icon/module';
import { KeyboardNavigation } from '../keyboardnavigation/module';
import {LKMenu} from "../menu/module";

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule,
    LKIcon,
    LKMenu,
    KeyboardNavigation
  ],
  declarations: [AutoCompleteComponent],
  exports     : [AutoCompleteComponent]
})
export class LKAutoComplete {
}

